import React, { Component } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';
import CommonPreviewFileModal from './components/CommonPreviewFileModal';

import CommonTokenExpired from './components/CommonTokenExpired';

import Cookies from "js-cookie";

/** withRouter */
import withRouter from "./components/withRouter"

/** start individual component */
import InputUserDataUser from './inputs/InputUserDataUser';
import SearchUserDataUser from './searchs/SearchUserDataUser';
import DataTableUserDataUser from './dataTables/DataTableUserDataUser';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/UserDataUserState';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `users`;
const URL = `api/master/${TABLE}`;

const rawProfile = Cookies.get("userProfile");
const userProfile = rawProfile ? JSON.parse(rawProfile) : {};

const allowedTypes = ["0", "1"];
const userPermit = allowedTypes.includes(userProfile.types);

class UserDataUser extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadMasterbase();
        await this.loadDataTable();
        await this.setDefaultSearchs();
    }

    loadMasterbase = async () => {
        let sets = [
            {key: "academy", filter: [{field: "status", value: "0"}]},
            {key: "enterprise", filter: [{field: "status", value: "0"}]},
            {key: "permission_name", filter: [{field: "status", value: "0"}]}
        ];

        Actions.loadMasterbase(this.updateState, sets);
    }

    loadDataTable = async (search=false) => { 
        const { Searchs, DataTable } = this.state;

        const cookieSearchs = {};
        if (userProfile.id && !["0","1"].includes(userProfile.types))  {
            cookieSearchs.id = { id: "id", value: userProfile.id };
        }

        const mergedSearchs = {
            ...Searchs,
            ...cookieSearchs,
            page: {
            id: "page",
            value: search ? 1 : DataTable.pagination.currentPage,
            },
        };

        await Actions.loadDataTable( 
            this.updateState, 
            `${URL}/pagination`, 
            fn.getInputSearch(mergedSearchs)
        );
    }

    setDefaultSearchs = async () => {
        let defaultsSearchs = {};

        if(['2','3','6'].includes(userProfile.types)){
            defaultsSearchs.types = userProfile.types;
            defaultsSearchs.fullname = userProfile.fullname;
        }
         switch (userProfile.types) {
            case "2": // academy
                defaultsSearchs.academy_id = userProfile.academy_id;
            break;
            case "3": // enterprise
                defaultsSearchs.enterprise_id = userProfile.enterprise_id;
            break;
            default:
                //(admin) ไม่เซ็ตค่า
            break;
        }
        await Actions.setDefaultSearchs(this.updateState,defaultsSearchs); 
        
    }

    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'OffCanvas', mode: 'update', bool: true},
            this.state.Inputs
        );
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
    }

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state;
    
        if (Action.Mode === 'update') {
            const newPassword = Inputs.new_password.value;
    
            Inputs.password.value = newPassword || '';
            Inputs.new_password.value = '';
        }
    
        const payload = fn.getInputForm({ ...Inputs });
    
        await Actions.submitData(
            this.updateState,
            URL,
            Action.Mode,
            payload,
            this.loadDataTable,
            null,
            this.state.Inputs
        );
    }

    componentDidMount = async () => {
        await this.initialize(); 
    }

    componentDidUpdate = async () => {}    

    render = () => {

        let { Action, Searchs, DataTable, Inputs, InputGroup, Masterbase, Deletes, Operation, Token } = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <Container>

                    <CommonPageHeader object={AppProps}/>

                    <CommonTokenExpired Token={Token} />

                    <CommonPreviewFileModal
                        Action={Action}
                        onClose={() => Actions.handleClosePreviewFile(this.updateState)}
                    />

                    <CommonToolbar 
                        config={AppProps.toolbar}
                        
                        userPermit={userPermit}
                        Operation={Operation}
                        Deletes={Deletes}

                        onToggleSearch={(e) => Actions.handleToggleItem(this.updateState, 'Operation', 'Search')}

                        onRefreshDataTable={async (e) => await this.loadDataTable()}
                        
                        onCreateItem={(e) => Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true)}
                        onModalAction={(e) => Actions.handleControlModal(this.updateState, e)}
                    />

                    <CommonToast 
                        toast={Action.Toast} 

                        onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                    />

                    <CommonConfirmModal 
                        Action={Action}
                        Deletes={Deletes}

                        onCallback={async (e) => { 
                            let result = await Actions.handleControlModal(this.updateState, e);
                            if(result.action){
                                if (result.section === 'Delete'){ await this.deleteData(); }
                            }
                         }}
                    />

                    <SearchUserDataUser 
                        Action={Action}
                        Searchs={Searchs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                        onSearch={async (e) => await this.loadDataTable(true)}
                    />

                    <DataTableUserDataUser 
                        Action={Action}
                        DataTable={DataTable}
                        Inputs={Inputs}
                        Deletes={Deletes}
                        Operation={Operation}
                        UserCookie={userProfile}
                        userPermit={userPermit}

                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        onDropDownChange={async(e, element, pk) => await this.updateSomething(e, element, pk) }

                        onCheckDelete={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)}
                        onCheckDeleteAll={(e, deletes) => Actions.handleDataTableToggleDeleteAll(this.updateState, e, deletes)}
                        onPaginationChange={(paging) => Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)}
                    />

                    <InputUserDataUser 
                        URL={URL}
                        
                        App={AppProps}

                        Action={Action}
                        Inputs={Inputs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                        
                        onPreviewFile={(e) => Actions.handlePreviewFile(this.updateState, e)}
                        onDeleteFile={(field, pk) => Actions.deleteFile(this.updateState, URL, field, pk)}

                        onCloseAlert={(e) => { Actions.handleCloseAlert(this.updateState, 'Alert', e); }}
                        onSubmit={async (e) => { await this.submitData()}}
                        
                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        
                        onDiscardSubmit={(e) => { Actions.handleDiscardInputs(this.updateState, 'Inputs'); }}
                        onClose={(e) => {
                                Actions.handleDiscardInputs(this.updateState, 'Inputs');
                                Actions.handleCloseInputForm(this.updateState, 'OffCanvas')
                            }
                        }
                    />

                </Container>
            </>
        )
    }
}

export default withRouter(UserDataUser);